import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../pages/About";
import Blogs from "../pages/Blogs";
import Contact from "../pages/Contact";
import Industries from "../pages/Industries";
import Career from "../pages/Career";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import AIServices from "../pages/services/AIServices";
import AppDevelopment from "../pages/services/AppDevelopment";
import WebsiteDevelopment from "../pages/services/WebsiteDevelopment";
import DigitalMarketing from "../pages/services/DigitalMarketing";
import CyberSecurity from "../pages/services/CyberSecurity";
import CloudServices from "../pages/services/CloudServices";
import ITConsulting from "../pages/services/ITConsulting";
import DataCenter from "../pages/services/DataCenter";
import Salesforce from "../pages/solution/Salesforce";
import ServiceNow from "../pages/solution/ServiceNow";
import Odoo from "../pages/solution/Odoo";
import SAP from "../pages/solution/SAP";
import MVPDevelopment from "../pages/solution/MVPDevelopment";
import AIMLSolution from "../pages/solution/AIMLSolution";
import ContactPopup from "../components/ContactPopup";

const ContactCtaNavigation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleContactClick = (event) => {
            const button = event.target.closest(
                "button.breadcrumb-btn, button.service-detail-btn, button.salesforce-contact-btn, button.clickcustomform"
            );

            if (!button || button.matches(".submit-btn-custom") || button.disabled) {
                return;
            }

            const label = button.textContent.trim().toLowerCase();
            const isContactCta =
                button.matches(".service-detail-btn, .salesforce-contact-btn, .clickcustomform") ||
                label.includes("connect") ||
                label.includes("contact");

            if (!isContactCta) {
                return;
            }

            event.preventDefault();
            navigate("/contact");
        };

        document.addEventListener("click", handleContactClick);
        return () => document.removeEventListener("click", handleContactClick);
    }, [navigate]);

    return null;
};

const Router = () => {

    const [headerData, setHeaderData] = useState([]);

    return (
        <BrowserRouter>

            <ContactCtaNavigation />
            <ContactPopup />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blogs />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/career" element={<Career />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/services/ai-services" element={<AIServices />} />
                <Route path="/services/app-development" element={<AppDevelopment />} />
                <Route path="/services/website-development" element={<WebsiteDevelopment />} />
                <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
                <Route path="/services/cyber-security" element={<CyberSecurity />} />
                <Route path="/services/cloud-services" element={<CloudServices />} />
                <Route path="/services/it-consulting" element={<ITConsulting />} />
                <Route path="/services/data-center" element={<DataCenter />} />

                <Route path="/salesforce" element={<Salesforce />} />
                <Route path="/servicenow" element={<ServiceNow />} />
                <Route path="/odoo" element={<Odoo />} />
                <Route path="/sap" element={<SAP />} />
                <Route path="/mvp-development" element={<MVPDevelopment />} />
                <Route path="/ai-ml" element={<AIMLSolution />} />
                <Route path="*" element={<Home />} />

            </Routes>
            <Footer headerData={headerData} />
        </BrowserRouter >


    )
}
export default Router;
